class HeaderMakersSearch extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    this.handleChange = this.handleChange.bind(this)
    this.searchField = this.externalEls.search.element
    this.listeners.add(this.searchField, 'change', this.handleChange)
    this.handleChange()
  }

  handleChange () {
    const partialReference = this.searchField.value.toLowerCase()
    const partialResults = this.makersList.filter(searchResult => {
      return searchResult.title.toLowerCase().indexOf(partialReference) > -1
    })
    let limit = 5
    let fragmentHTML = ''
    partialResults.forEach(searchResult => {
      if (limit <= 0) return
      const emboldenedCopy = searchResult.title
        .toLowerCase()
        .replace(partialReference, `<b>${partialReference}</b>`)
      fragmentHTML += `<li class="hd-MakersSearch_Item"><a href="${searchResult.url}" class="hd-MakersSearch_Anchor">${emboldenedCopy}</a></li>`
      limit--
    })
    fragmentHTML += !partialResults.length
      ? '<li class="hd-MakersSearch_Item"><span class="hd-MakersSearch_Span">No results found</span></li>'
      : ''
    this?.closest('.hd-MakersSearch')?.classList?.toggle(
      'hd-MakersSearch-noResults',
      !partialResults.length,
    )
    this?.closest('.kuQuickSearch')?.classList?.toggle(
      'kuNoMakersResults',
      !partialResults.length,
    )
    this.els['makers-list'].element.innerHTML = fragmentHTML
  }

  connectedCallback () {
    const makersList = []
    this.els.title.elements.forEach(li => {
      makersList.push({
        title: li.getAttribute('data-title'),
        url: li.getAttribute('data-url'),
      })
    })
    this.makersList = makersList
    return super.connectedCallback()
  }
}

if (!customElements.get('header-makers-search')) {
  customElements.define('header-makers-search', HeaderMakersSearch)
}
